module.exports = __webpack_public_path__ + "img/delete1.961c2ee1.svg";